import React from 'react';

export default function BoxWithShadowAndUnderline(props) {
  return (
    <div
      id="box-with-shadow-and-underline"
      style={{ borderBottom: `5px solid ${props.tenant.secondary}` }}
    >
      {props.children}
    </div>
  );
}
